import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { authService } from '../../services/firebaseService';

const HomePage = () => {
  const user = authService.getCurrentUser();

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} className="text-center">
          <h1 className="display-4 mb-4">Bienvenue sur Tournoi Manager</h1>
          <p className="lead mb-4">
            La plateforme de gestion de tournois sportifs simple et efficace
          </p>
          
          {!user ? (
            <div className="mt-5">
              <Link to="/login">
                <Button variant="primary" size="lg" className="mx-2">
                  Se connecter
                </Button>
              </Link>
              <Link to="/register">
                <Button variant="outline-primary" size="lg" className="mx-2">
                  S'inscrire
                </Button>
              </Link>
            </div>
          ) : (
            <div className="mt-5">
              <Link to="/dashboard">
                <Button variant="primary" size="lg" className="mx-2">
                  Accéder à mon tableau de bord
                </Button>
              </Link>
            </div>
          )}

          <div className="mt-5">
            <h2 className="h3 mb-4">Fonctionnalités principales</h2>
            <Row className="mt-4">
              <Col md={4}>
                <div className="mb-4">
                  <h3 className="h5">Gestion d'athlètes</h3>
                  <p>Créez et gérez facilement vos listes d'athlètes</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-4">
                  <h3 className="h5">Organisation de tournois</h3>
                  <p>Créez des tournois et gérez les inscriptions</p>
                </div>
              </Col>
              <Col md={4}>
                <div className="mb-4">
                  <h3 className="h5">Suivi des résultats</h3>
                  <p>Suivez les résultats et générez des classements</p>
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default HomePage;
